export default [
  { title: "Create a permission profile", icon: "", link: "/docs/create-permission" },
  { title: "Update individual permission settings", icon: "", link: "/docs/update-permission" },
  { title: "Set a permission profile", icon: "", link: "/docs/set-permission" },
  { title: "Delete a permission profile", icon: "", link: "/docs/delete-permission" },
];
